import { render } from "./ViewEmplacementPage.vue?vue&type=template&id=64a0d3f4&ts=true"
import script from "./ViewEmplacementPage.vue?vue&type=script&lang=ts"
export * from "./ViewEmplacementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__